import * as Switch from '@wandb/weave/components/Switch';
import * as React from 'react';
import {twMerge} from 'tailwind-merge';

import {SettingLabel} from '../components/SettingLabel';
import {type ExcludeOutliersValues} from '../types';
import {areOutliersExcluded} from '../utils';

type LinePlotConfigExcludeOutliersProps = {
  className?: string;
  excludeOutliers: ExcludeOutliersValues;
  onExcludeOutliersChange: (value: boolean) => void;
  disabled?: boolean;
};

export const LinePlotConfigExcludeOutliers = ({
  className,
  excludeOutliers,
  onExcludeOutliersChange,
  disabled = false,
}: LinePlotConfigExcludeOutliersProps) => {
  // In "Line" (min-max-last) full fidelity this control is a no-op:
  // there's no band to hide and no outlier y-scaling in that mode.
  // The parent disables it, so force the displayed value to off.
  const checked = !disabled && areOutliersExcluded(excludeOutliers);
  return (
    <fieldset className={twMerge('text-moon-800', className)}>
      <div className="mt-4 flex items-center justify-between">
        <div>
          <div className="flex items-center gap-4">
            <SettingLabel className="w-fit" text="Outliers" />
          </div>
          <p className="text-sm text-moon-500">
            Exclude extreme outliers when scaling charts
          </p>
        </div>
        <Switch.Root
          aria-label={'Outliers'}
          disabled={disabled}
          checked={checked}
          onCheckedChange={onExcludeOutliersChange}>
          <Switch.Thumb checked={checked} />
        </Switch.Root>
      </div>
    </fieldset>
  );
};
